import { useEffect, ReactNode } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { setSessionTokenGetter } from '../lib/api'
import { setSessionTokenGetter as setAnchorBrowserSessionTokenGetter } from '../lib/anchor-browser-api'
import { setSessionTokenGetter as setMCPSessionTokenGetter } from '../lib/mcp-client'

interface ClerkApiProviderProps {
  children: ReactNode
}

export function ClerkApiProvider({ children }: ClerkApiProviderProps) {
  const { getToken, isSignedIn } = useAuth()

  useEffect(() => {
    // Set up the session token getter for both API clients
    const tokenGetter = async () => {
      try {
        // Only try to get Clerk token if user is signed in
        if (isSignedIn) {
          return await getToken()
        }
        return null
      } catch (error) {
        console.log('Clerk session token not available, using Cloudflare Access authentication')
        return null
      }
    }

    setSessionTokenGetter(tokenGetter)
    setAnchorBrowserSessionTokenGetter(tokenGetter)
    setMCPSessionTokenGetter(tokenGetter)
  }, [getToken, isSignedIn])

  return <>{children}</>
}
